import {DataStatus} from 'platform/components';
import {Grid, Show, VStack} from 'platform/foundation';

import {isNotNil} from 'ramda-adjunct';

import {useGetVehicleV2Query} from '@dms/api/sales';

import {suffixTestId, TestIdProps} from 'shared/web';

import {DetailsSideColumn} from '../DetailsSideColumn/DetailsSideColumn';
import {VehicleDetail} from './components/VehicleDetail';

interface VehicleContentDetailsProps extends TestIdProps {
  vehicleId: string;
  isSaleVehicle: boolean;
}

export function VehicleContentDetails(props: VehicleContentDetailsProps) {
  const {data: vehicle, isLoading, isError} = useGetVehicleV2Query({vehicleId: props.vehicleId});

  return (
    <DataStatus isLoading={isLoading} isError={isError}>
      <Show when={isNotNil(vehicle)}>
        <Grid columns={[1, 2]} spacing={2}>
          <VehicleDetail
            vehicle={vehicle!}
            vehicleId={props.vehicleId}
            isSaleVehicle={props.isSaleVehicle}
          />
          <VStack spacing={4}>
            <DetailsSideColumn
              vehicleId={props.vehicleId}
              isIntegrationsShown
              isDetailsTab
              data-testid={suffixTestId('detailsSideColumn', props)}
            />
          </VStack>
        </Grid>
      </Show>
    </DataStatus>
  );
}
